<template>
  <div>
     <div v-html="bottomHtmlText"></div>
  </div>
</template>

<script>
export default {
  props: {
    bottomHtmlText: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
@media (max-width: 768px) {
  .public-home-page {
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    margin-left: 0px;
    margin-right: 0px;
  }
}
</style>
